import React from "react";
import {
  CPlusPlus,
  PandasBadge,
  SkillBadge,
  TailwindBadge,
} from "../components/skillbadge";

const SkillsPage = () => {
  return (
    <>
      <div id="skills">
        <h2 className="md:text-5xl text-center font-bold text-white text-4xl pt-10">
          🌀 Skills
        </h2>
        <section className="mt-12 mb-4 mx-auto max-w-screen-2xl h-auto pb-10 px-4 sm:px-8 bg-[#090E34]">
          <div className="grid grid-cols-2 auto-rows-auto lg:grid-cols-4 md:grid-cols-3 gap-5 place-items-center h-auto p-10 md:p-16">
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original-wordmark.svg" />
            <CPlusPlus />
            <SkillBadge
              title={"React"}
              source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original-wordmark.svg"
            />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-plain-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-plain-wordmark.svg" />
            <TailwindBadge />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-plain.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-plain-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/storybook/storybook-original.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-plain.svg" />
          </div>
          <h2 className="md:text-4xl text-center font-bold text-white text-3xl">
            🌀 Currently exploring
          </h2>
          <div className="grid grid-cols-2 auto-rows-auto lg:grid-cols-4 md:grid-cols-3 gap-5 place-items-center h-auto p-10 md:p-16">
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mocha/mocha-plain.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-plain-wordmark.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" />
            <SkillBadge source="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg" />
            <PandasBadge />
          </div>
        </section>
      </div>
    </>
  );
};

export default SkillsPage;
